import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../../models/user.model';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  user: User = new User();
  errorMessage: any = null;

  constructor(
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.auth.loginWithToken(token).subscribe({
        next: (user: User) => {
          this.toastr.success(`¡Bienvenido ${user.name}!`);
          this.router.navigateByUrl('/steps/route');
        },
        error: () => {
          this.errorMessage = 'Token invalido';
          this.toastr.error('Fallo la autenticacion');
        }
      });
    }
  }

    onSubmit(form): void {

      if (form.invalid) {
        return;
      }

      this.auth.login(this.user).subscribe({
        next: (user: User) => {
          this.toastr.success(`¡Bienvenido ${user.name}!`);
          this.router.navigateByUrl('/steps/route');
        },
        error: () => {
          this.errorMessage = 'Los datos ingresados no son correctos';
          this.toastr.error('Credenciales incorrectas');
        }
      });
}


}
